import { render, staticRenderFns } from "./OrderKids.vue?vue&type=template&id=62318cec&scoped=true"
import script from "./OrderKids.vue?vue&type=script&lang=js"
export * from "./OrderKids.vue?vue&type=script&lang=js"
import style0 from "./OrderKids.vue?vue&type=style&index=0&id=62318cec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62318cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62318cec')) {
      api.createRecord('62318cec', component.options)
    } else {
      api.reload('62318cec', component.options)
    }
    module.hot.accept("./OrderKids.vue?vue&type=template&id=62318cec&scoped=true", function () {
      api.rerender('62318cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKids.vue"
export default component.exports